import { useEffect, useState } from 'react';
import { api, fmt, fmtDate, fmtDateTime, getUser, setRates } from '../api';
import { Modal, Field, Input, useToast, Loading } from '../ui';
import { Icons } from '../icons';

export default function Currencies() {
  const [list, setList] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const [view, setView] = useState<any>(null);
  const [hFrom, setHFrom] = useState('');
  const [hTo, setHTo] = useState('');
  const [busy, setBusy] = useState(false);
  const parseRate = (v: any) => { const n = parseFloat(String(v).replace(/\s/g, '').replace(',', '.')); return isNaN(n) ? 1 : n; };
  const toast = useToast();
  const user = getUser();
  // Kurs butun hisobotga ta'sir qiladi — sotuv roli o'zgartira olmaydi
  const canEdit = ['admin', 'rahbar'].includes(user?.role);
  const canCreate = ['admin', 'rahbar'].includes(user?.role);
  const base = list?.find((c) => c.isBase);

  const load = () => api.get('/currencies').then((cs) => { setList(cs); setRates(cs); });
  useEffect(() => { load(); }, []);

  const refresh = async () => {
    setBusy(true);
    try {
      const r = await api.post('/currencies/refresh', {});
      if (r?.ok === false) toast('Markaziy bankdan olinmadi: ' + (r.error || 'noma\'lum xato'), true);
      else if (!r?.updated?.length) toast('Kurslar allaqachon dolzarb');
      else toast(r.updated.map((u: any) => `${u.code}: ${fmt(u.old, u.old >= 100 ? 0 : 4)} → ${fmt(u.rate, u.rate >= 100 ? 0 : 4)}`).join(' · '));
      load();
    } catch (e: any) { toast(e.message, true); }
    finally { setBusy(false); }
  };

  const save = async () => {
    try {
      // Kurs "1 USD = X birlik" ko'rinishida kiritiladi -> rateToBase shu qiymat
      const body = { ...edit, rateToBase: edit.isBase ? 1 : parseRate(edit.rateToBase) };
      if (edit.id) await api.patch('/currencies/' + edit.id, body);
      else await api.post('/currencies', body);
      toast('Saqlandi'); setEdit(null); load();
    } catch (e: any) { toast(e.message, true); }
  };
  const remove = async (c: any) => {
    if (!confirm(`${c.code} valyutasi o'chirilsinmi?`)) return;
    try { await api.del('/currencies/' + c.id); toast("O'chirildi"); load(); } catch (e: any) { toast(e.message, true); }
  };

  if (!list) return <Loading />;
  const baseSym = base?.symbol || base?.code || '$';

  return (
    <div>
      <div className="page-head">
        <div>
          <h1 className="page-title">Valyutalar va kurslar</h1>
          <p className="page-sub">Asosiy valyuta — <b>{base?.code}</b>. Kurslar «1 {base?.code} = necha birlik» ko'rinishida kiritiladi.
            {' '}Avto belgisi turgan valyutalar O'zbekiston Markaziy banki kursidan kuniga yangilanadi.</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          {canCreate && <button className="btn" disabled={busy} onClick={refresh}>
            <Icons.refresh size={17} /> {busy ? 'Yangilanmoqda…' : 'Markaziy bankdan yangilash'}
          </button>}
          {canCreate && <button className="btn btn-primary" onClick={() => setEdit({ rateToBase: '', autoUpdate: true })}><Icons.plus size={17} /> Valyuta qo'shish</button>}
        </div>
      </div>

      <div className="table-wrap">
        <table>
          <thead><tr>
            <th>Kod</th><th>Nomi</th><th>Belgi</th><th className="num">Kurs (1 {base?.code} = )</th><th>Manba</th><th>Kurs sanasi</th><th>Holat</th><th style={{ textAlign: 'right' }}>Amallar</th>
          </tr></thead>
          <tbody>
            {list.map((c) => {
              // Kurs 3 kundan eski bo'lsa ogohlantiramiz (dam olish kunlari CBU yangilamaydi)
              const ageDays = c.rateDate ? Math.floor((Date.now() - new Date(c.rateDate).getTime()) / 86400000) : null;
              const stale = c.autoUpdate && (ageDays == null || ageDays > 3);
              return (
              <tr key={c.id}>
                <td><b className="link">{c.code}</b></td>
                <td>{c.name}</td>
                <td>{c.symbol || '—'}</td>
                <td className="num" style={{ fontWeight: 600 }}>
                  {c.isBase ? <span className="muted">asosiy</span> : <>1 {baseSym} = {fmt(c.rateToBase, Number(c.rateToBase) >= 100 ? 0 : 4)} {c.symbol || c.code}</>}
                </td>
                <td>
                  {c.isBase ? <span className="muted">—</span>
                    : c.autoUpdate ? <span className="badge b-received" title="Markaziy bankdan avtomatik">⟳ Avto (CBU)</span>
                    : <span className="badge b-draft" title="Faqat qo'lda o'zgaradi">✎ Qo'lda</span>}
                </td>
                <td className={stale ? 'down' : ''} title={stale ? 'Kurs eskirgan' : ''}>
                  {c.isBase ? '—' : c.rateDate ? fmtDate(c.rateDate) : <span className="muted">hech qachon</span>}
                  {stale && ' ⚠'}
                </td>
                <td>{c.isBase ? <span className="badge b-received">★ Asosiy</span> : ''}</td>
                <td>
                  <div className="act-row" style={{ justifyContent: 'flex-end', display: 'flex' }}>
                    {!c.isBase && <button className="act act-hist" title="Kurslar tarixi" onClick={() => api.get('/currencies/' + c.id).then(setView)}><Icons.history size={17} /></button>}
                    {canEdit && <button className="act act-edit" title="Tahrirlash" onClick={() => setEdit({ ...c })}><Icons.edit size={16} /></button>}
                    {user?.role === 'admin' && !c.isBase && <button className="act act-del" title="O'chirish" onClick={() => remove(c)}><Icons.trash size={16} /></button>}
                  </div>
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {edit && (
        <Modal title={edit.id ? `${edit.code} — tahrirlash` : 'Yangi valyuta'} onClose={() => setEdit(null)}>
          <div className="grid-2">
            <Field label="Kod (USD, CNY...) *"><Input value={edit.code || ''} disabled={!!edit.id} onChange={(e) => setEdit({ ...edit, code: e.target.value.toUpperCase() })} /></Field>
            <Field label="Nomi *"><Input value={edit.name || ''} onChange={(e) => setEdit({ ...edit, name: e.target.value })} /></Field>
            <Field label="Belgi"><Input value={edit.symbol || ''} onChange={(e) => setEdit({ ...edit, symbol: e.target.value })} /></Field>
            <Field label={`Kurs: 1 ${base?.code || 'USD'} = necha ${edit.code || 'birlik'}`}>
              <Input type="text" inputMode="decimal" disabled={edit.isBase} placeholder="masalan 12000 yoki 6.75"
                value={edit.isBase ? '1' : (edit.rateToBase ?? '')} onChange={(e) => setEdit({ ...edit, rateToBase: e.target.value })} />
            </Field>
          </div>
          {!edit.isBase && (
            <label style={{ display: 'flex', gap: 9, alignItems: 'flex-start', marginTop: 4, cursor: 'pointer' }}>
              <input type="checkbox" style={{ marginTop: 3 }} checked={!!edit.autoUpdate}
                onChange={(e) => setEdit({ ...edit, autoUpdate: e.target.checked })} />
              <span>
                <b>Markaziy bank kursidan avtomatik yangilansin</b>
                <div className="muted" style={{ fontSize: 12.5, marginTop: 2 }}>
                  {edit.autoUpdate
                    ? 'Kurs har kuni CBU dan olinadi; qo\'lda kiritganingiz keyingi yangilanishda almashadi.'
                    : 'Kurs faqat siz kiritgancha qoladi — ichki kelishilgan kurs uchun.'}
                </div>
              </span>
            </label>
          )}
          {edit.isBase && <p className="muted" style={{ fontSize: 12 }}>Asosiy valyuta — kurs doim 1.</p>}
          {!edit.isBase && edit.rateToBase !== '' && edit.rateToBase != null && <p className="muted" style={{ fontSize: 12.5 }}>Ya'ni: 1 {base?.code} = {fmt(parseRate(edit.rateToBase), parseRate(edit.rateToBase) >= 100 ? 0 : 4)} {edit.code}</p>}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
            <button className="btn" onClick={() => setEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={save}>Saqlash</button>
          </div>
        </Modal>
      )}

      {view && (() => {
        const rows = view.history.filter((h: any) => {
          const d = new Date(h.date);
          if (hFrom && d < new Date(hFrom)) return false;
          if (hTo && d > new Date(hTo + 'T23:59:59')) return false;
          return true;
        });
        return (
        <Modal title={`Kurslar tarixi: ${view.code}`} onClose={() => { setView(null); setHFrom(''); setHTo(''); }}>
          <div className="filters" style={{ marginBottom: 14 }}>
            <div className="field" style={{ margin: 0 }}><label>Dan</label><Input type="date" value={hFrom} onChange={(e) => setHFrom(e.target.value)} /></div>
            <div className="field" style={{ margin: 0 }}><label>Gacha</label><Input type="date" value={hTo} onChange={(e) => setHTo(e.target.value)} /></div>
            {(hFrom || hTo) && <button className="btn btn-sm" style={{ alignSelf: 'flex-end' }} onClick={() => { setHFrom(''); setHTo(''); }}>Tozalash</button>}
          </div>
          {!rows.length ? <p className="empty">Kurs o'zgarishi tarixi yo'q</p> : (
            <div className="table-wrap">
              <table>
                <thead><tr><th>Sana / vaqt</th><th>Manba</th><th className="num">Kurs</th><th className="num">O'zgarish</th></tr></thead>
                <tbody>{rows.map((h: any, i: number) => {
                  const prev = rows[i + 1];
                  const diff = prev ? Number(h.rateToBase) - Number(prev.rateToBase) : null;
                  return (
                    <tr key={h.id}>
                      <td>{fmtDateTime(h.date)}</td>
                      <td>{h.source === 'cbu'
                        ? <span className="badge b-received">⟳ CBU</span>
                        : <span className="badge b-draft">✎ Qo'lda</span>}</td>
                      <td className="num" style={{ fontWeight: 600 }}>{fmt(h.rateToBase, Number(h.rateToBase) >= 100 ? 0 : 4)}</td>
                      <td className="num">{diff == null ? '—' : diff > 0 ? <span className="up">▲ +{fmt(diff, Number(h.rateToBase) >= 100 ? 0 : 4)}</span> : diff < 0 ? <span className="down">▼ {fmt(diff, Number(h.rateToBase) >= 100 ? 0 : 4)}</span> : '—'}</td>
                    </tr>
                  );
                })}</tbody>
              </table>
            </div>
          )}
        </Modal>
        );
      })()}
    </div>
  );
}
